// extracted by mini-css-extract-plugin
export default {"root":"RTwK9Q","description":"wYOR1m","form":"QvW0FI","label":"VChojN","input":"laq_ZO","submit":"ZaELJI"};